import React, { useState, useEffect } from 'react';
import styles from './RoleManagement.module.css';

const EditRoleModal = ({ show, role, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        roleName: '',
        description: ''
    });

    useEffect(() => {
        if (role) {
            setFormData({
                roleName: role.name,
                description: role.description || ''
            });
        }
    }, [role]);

    if (!show || !role) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await onSubmit(role.id, formData);
        if (result.success) {
            onClose();
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Edit Role</h2>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.modalBody}>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Role Name </label>
                            <input
                                type="text"
                                className={styles.input}
                                required
                                value={formData.roleName}
                                onChange={(e) => setFormData({ ...formData, roleName: e.target.value })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Description</label>
                            <textarea
                                className={styles.textarea}
                                rows="3"
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className={styles.modalFooter}>
                        <button type="button" className={styles.cancelButton} onClick={onClose}>Cancel</button>
                        <button type="submit" className={styles.submitButton}>Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditRoleModal;